export default __webpack_public_path__ + "static/media/TuyaWifiDualRelaySwitch.5aa61c1c.png";